export const convertUtcToLocalDate = (utcDateMs: number, timeZone?: string) => {
    const timezoneFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone,
        timeZoneName: 'short'
    });

    const formattedDate = timezoneFormatter.format(utcDateMs);
    const date = new Date(Date.parse(formattedDate));
    return date;
};
